import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import Content from '../../common/template/content';
import Tabs from '../../common/tab/tabs';
import TabsHeader from '../../common/tab/tabsHeader';
import TabsContent from '../../common/tab/tabsContent';
import TabHeader from '../../common/tab/tabHeader';
import TabContent from '../../common/tab/tabContent';
import PermissaoUsuario from '../../auth/permissao';
import { init, create, update, clearPendingNavFromNotification } from './ordemServicoActions';

import List from './ordemServicoList';
import Form from './ordemServicoForm';
import Materiais from './ordemServicoMateriais';
import Interacoes from './ordemServicoInteracoes';
import Relatorio from './ordemServicoRelatorio';
import Graficos from './ordemServicoGraficos';
import TabFooter from './ordemServicoTabFooter';
import OrdemServicoFinalizarModal from './ordemServicoFinalizarModal';

class OrdemServico extends Component {
  componentWillMount() {
    if (this.props.pendingNavFromNotification) {
      this.props.clearPendingNavFromNotification();
      return;
    }

    this.props.init();
  }

  render() {
    return (
      <div>
        <OrdemServicoFinalizarModal />
        <Content>
          <Tabs>
            <TabsHeader>
              <TabHeader label="Listar" icon="bars" target="tabList" />
              <PermissaoUsuario tela="CadOrdemServico" campo="incluir" condicao={true}>
                <TabHeader label="Abrir OS" icon="plus" target="tabCreate" />
              </PermissaoUsuario>
              <PermissaoUsuario tela="CadOrdemServico" campo="alterar" condicao={true}>
                <TabHeader label="Alterar" icon="pencil-alt" target="tabUpdate" />
              </PermissaoUsuario>
              <PermissaoUsuario tela="CadOrdemServico" campo="materiais" condicao={true}>
                <TabHeader label="Materiais" icon="boxes" target="tabMateriais" />
              </PermissaoUsuario>
              <PermissaoUsuario tela="CadOrdemServico" campo="interacoes" condicao={true}>
                <TabHeader label="Interações" icon="comments" target="tabInteracoes" />
              </PermissaoUsuario>
              <PermissaoUsuario tela="CadOrdemServico" campo="graficos" condicao={true}>
                <TabHeader label="Gráficos" icon="chart-pie" target="tabGraficos" />
              </PermissaoUsuario>
              <PermissaoUsuario tela="CadOrdemServico" campo="relatorio" condicao={true}>
                <TabHeader label="Relatório" icon="chart-bar" target="tabRelatorio" />
              </PermissaoUsuario>
            </TabsHeader>
            <TabsContent>
              <TabContent id="tabList">
                <List />
              </TabContent>
              <TabContent id="tabCreate">
                <Form onSubmit={this.props.create} submitClass="primary" submitLabel="Abrir OS" premiumLayout />
              </TabContent>
              <TabContent id="tabUpdate">
                <Form onSubmit={this.props.update} submitClass="primary" submitLabel="Salvar" premiumLayout isUpdate />
              </TabContent>
              <TabContent id="tabMateriais">
                <Materiais />
                <TabFooter />
              </TabContent>
              <TabContent id="tabInteracoes">
                <Interacoes />
                <TabFooter />
              </TabContent>
              <TabContent id="tabGraficos">
                <Graficos />
              </TabContent>
              <TabContent id="tabRelatorio">
                <Relatorio />
              </TabContent>
            </TabsContent>
          </Tabs>
        </Content>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  pendingNavFromNotification: state.manutencaoOS && state.manutencaoOS.pendingNavFromNotification,
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ init, create, update, clearPendingNavFromNotification }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(OrdemServico);
